export default "https://cdn-static.gokick.com/assets/27898be65df9afd7cb19e5714fb6a6df6232ba84/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";